import { useState } from "react";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Link from "@mui/material/Link";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

import { useCustomerContext } from "../../../Context/CustomerContext";

const RealTimePromotionCard = () => {
  const [realTimePopoverAnchor, setRealTimePopoverAnchor] = useState<HTMLElement | null>(null);
  const { customer } = useCustomerContext();

  const handleRealTimePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setRealTimePopoverAnchor(event.currentTarget);
  };

  const handleRealTimePopoverClose = () => {
    setRealTimePopoverAnchor(null);
  };

  const realTimePopoverOpen = Boolean(realTimePopoverAnchor);

  return (
    <>
      <Link
        component="button"
        underline="none"
        variant="body2"
        onClick={handleRealTimePopoverOpen}
        data-cy="real-time-promotion-link"
        sx={{
          textAlign: "left",
          mt: 1.25,
          textDecoration: "underline dotted",
          textDecorationColor: "currentColor",
          color: "text.primary",
        }}
      >
        Reduce your risk with real-time anomalies
      </Link>
      <Popover
        open={realTimePopoverOpen}
        anchorEl={realTimePopoverAnchor}
        onClose={handleRealTimePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        data-cy="real-time-promotion-popover"
        sx={{
          "& .MuiPopover-paper": {
            mt: 0.5,
          },
        }}
      >
        <Card sx={{ maxWidth: 360 }}>
          <CardHeader
            title="Enable near real-time anomalies"
            slotProps={{
              title: { variant: "subtitle1", fontWeight: 500 },
            }}
            sx={{ pb: 1 }}
          />
          <CardContent sx={{ pt: 0 }}>
            <Typography variant="body2">
              You can significantly reduce your cloud cost risks by enabling near real-time anomalies for the following
              services:
            </Typography>
            <List dense sx={{ py: 0 }}>
              <ListItem sx={{ py: 0.25 }}>
                <Typography variant="body2">• AWS EC2</Typography>
              </ListItem>
              <ListItem sx={{ py: 0.25 }}>
                <Typography variant="body2">• AWS RDS</Typography>
              </ListItem>
            </List>
            <Button
              variant="outlined"
              size="medium"
              fullWidth
              onClick={() => {
                window.open(`/customers/${customer.id}/integrate/aws/link?openRealTimeAnomaly=1`, "_blank");
                handleRealTimePopoverClose();
              }}
              sx={{ mt: 2 }}
              data-cy="real-time-promotion-enable-button"
              endIcon={<OpenInNewIcon fontSize="small" />}
            >
              Enable near real-time anomalies
            </Button>
          </CardContent>
        </Card>
      </Popover>
    </>
  );
};

export default RealTimePromotionCard;
